<template>
    <div>
           <Heador :title="'申请二维码'" :back="true" > </Heador>
        <!-- <div class='center'>
            <div class='title'>车牌号 : {{plateNumber}}</div>

            <div>单价 : {{$route.query.is}} ( 元 / 升 )</div>

            <div>申请升数 : {{$route.query.data.planQuotaLitre}} ( 升 )</div>

            <div>申请金额 : {{$route.query.data.planQuotaRmb}} ( 元 )</div>


              <div class="wrapper" @click="qrCodeShow = false">
              <div class="fffborder">
                <div class="qrcode block" ref="qrCodeUrl" />
              </div>
            </div>

            <div>距离失效还剩 {{overTime}} 秒</div>


        </div> -->
        <section>
            <div class="bg">
                <div class="head-title">
                    <div class="top">
                        <div class="num">车牌号：{{plateNumber}}</div>
                       
                        
                        <div class="number">
                            <div class="left">申请升数</div>
                            <div class="right">{{$route.query.data.planQuotaLitre}} ( L )</div>
                        </div>
                        <!-- <div class="number">
                            <div class="left">单价</div>
                            <div class="right">{{$route.query.is}} (升)</div>
                        </div>
                         <div class="number">
                            <div class="left">预计金额</div>
                            <div class="right">{{$route.query.data.planQuotaLitre * $route.query.is}} (元)</div>
                        </div> -->
                    </div>
                    <div class="bottom">
                        <div class="corner">
                            <div class="qrcode" ref="qrCodeUrl" ></div>
                        </div>
                        <div class="time">二维码有效期：{{ overTime }} 秒</div>
                        <div class="scan">请管理员扫描此二维码</div>

                    </div>

                </div>
            </div>
        </section>

      
    </div>
</template>

<script>
import QRCode from "qrcodejs2";
import Heador from "./header";
import {verifyConfirm} from "@/api/center/autonomously";



export default {
    data(){
        return{
            plateNumber:JSON.parse(localStorage.getItem("currentPlateNumbers")).plateNumber,
            overTime:'',
            timer:undefined,
        }
    },
    components:{
        Heador
    },
    mounted(){
        console.log(this.$route.query);
        this.creatQrCode()
        //获取过期时间
        this.getOverTime()
    },
    methods:{
        creatQrCode() {
        let long = document.documentElement.clientWidth * (100 / 375)

              var qrcode = new QRCode(this.$refs.qrCodeUrl, {
              text:
                // process.env.VUE_APP_BASE_API +
                // "?_gp=admin.order&_mt=detailByCode&orderNo=" +
                this.$route.query.data.applyId, // 需要转换为二维码的内容
              width: long,
              height: long,
              colorDark: "#000000",
              colorLight: "#ffffff",
              correctLevel: QRCode.CorrectLevel.H,
            });
        },
        getOverTime(){
            let time = new Date(this.$route.query.data.expiresTime)
            time = time.getTime()
            let thisTime = new Date()
            thisTime = thisTime.getTime()
            let sum = time - thisTime
            this.overTime = (sum/1000).toFixed(0)
            
            this.timer = setInterval( ()=>{
                this.overTime--
                console.log(this.overTime);
                
                verifyConfirm(this.$route.query.data.applyId).then(res=>{
                    if(res.data.data.status === '2'){
                        this.$toast(res.data.errmsg)
                        this.$router.push({
                            name:'autonomouslyDetail',
                            params:res.data.data.applyVo
                        })
                    }
                })
                if(this.overTime <= 0){
                    this.$toast('申请以失效,请您重写申请!')
                    this.$router.replace('/my')
                }
            },1000)
            
        }

        
    },
    destroyed(){
        clearInterval(this.timer)
    }
    
}
</script>

<style lang='less' scoped>
   

    section {
        height: calc(100vh - 0.88rem /* 44/50 */);
        overflow: scroll;
        display: flex;
        flex-direction: column;
        align-items: center;
        position: relative;
        // margin-top: 0.88rem /* 44/50 */;
        padding-top: .88rem;
        background-color: #fff;
    }

    .bg {
        width: 100vw;
        display: flex;
        flex-direction: column;
        align-items: center;
        background: url(../../assets/images/refuelManage_bg1.png) no-repeat 0px 0px;
        background-size: 7.5rem 2.92rem /* 146/50 */;

        .head-title {
            width: 88%;
            height: 6.6rem /* 395/50 */;
            display: flex;
            flex-direction: column;
            align-items: center;
            background: rgba(255, 255, 255);
            box-shadow: 0px 0px 10px 0px rgba(0, 0, 0, 0.1);
            border-radius: 5px;
            margin-top: 1.42rem /* 46/50 */;
            padding: .2rem 0 .6rem;
            // background: url(../../assets/images/qrcode_bg.png) no-repeat 0px 0px;
            // background-size: 100%;
            .top {
                width: 100%;
                padding: 0.6rem /* 30/50 */ 0.5rem /* 25/50 */ 0.4rem /* 20/50 */;
                border-bottom: 1px solid #EFEFEF;
                box-sizing: border-box;
            }

            .num {
                font-size: 0.36rem /* 18/50 */;
                font-family: PingFang SC;
                font-weight: bold;
                color: #293370;
                margin-bottom: 0.2rem /* 10/50 */;
                text-align: center;
            }

            .txt {
                font-size: 0.28rem /* 14/50 */;
                font-family: PingFang SC;
                font-weight: 500;
                color: #293370;
                text-align: center;
            }

            .number {
                display: flex;
                justify-content: space-between;
                font-size: 0.36rem /* 18/50 */;
                font-family: PingFang SC;
                font-weight: 500;
                color: #293370;
                margin-top: .3rem /* 15/50 */;
            }

            .bottom {
                display: flex;
                flex-direction: column;
                align-items: center;
                padding: 0.4rem /* 20/50 */;
                box-sizing: border-box;

                .time {
                    margin-top: .4rem /* 20/50 */;
                    font-size: 0.24rem /* 12/50 */;
                    font-family: PingFang SC;
                    font-weight: 500;
                    color: #26306E;
                }
            }
        }
    }

    .corner {
        // width: 147px;
        // height: 147px;
        width: 30vw;
        height: 30vw;
        background: url(../../assets/images/corner.png) no-repeat 0px 0px;
        background-size: 100% 100%;
        display: flex;
        justify-content: center;
        align-items: center;
       
    }
    .scan{
        font-size: .32rem;
    }
</style>